import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import IconCheckmark from 'client/icons/Checkmark'
import InformationBox from 'src/comps/InformationBox'
import Price from 'client/components/Price'

import { PendingToPay, Row, Text, Title } from './styles'

import messages from './messages'

const PayAll = ({ currency, pendingAmount }) => {
  const intl = useIntl()

  return (
    <div>
      <Row>
        <Title>
          <FormattedMessage {...messages.payNow} />
        </Title>

        <Text>
          <FormattedMessage {...messages.enterCard} />
        </Text>
      </Row>

      <Row>
        <InformationBox
          icon={<IconCheckmark />}
          text={intl.formatMessage(messages.cancelRemainExplain)}
          title={intl.formatMessage(messages.cancellationPoliciesRemain)}
        />
      </Row>

      <Row>
        <PendingToPay>
          <FormattedMessage {...messages.pendingToPay} tagName="div" />
          <Price amount={pendingAmount} currency={currency} />
        </PendingToPay>
      </Row>
    </div>
  )
}

PayAll.propTypes = {
  brand: PropTypes.string,
  currency: PropTypes.string,
  expiryDate: PropTypes.string,
  handleCloseModal: PropTypes.func,
  holder: PropTypes.string,
  number: PropTypes.string,
  partialPay: PropTypes.bool,
  partialAmounts: PropTypes.instanceOf({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  pendingAmount: PropTypes.number,
  purchaseId: PropTypes.string,
  roomName: PropTypes.string,
}

export default PayAll
